<h1 mat-dialog-title>Add people to Stream: {{ data.name }}</h1>
<div mat-dialog-content>
    <frog-user-picker #picker label="Add Members"></frog-user-picker>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-stroked-button color="primary" (click)="accept()">Add</button>
</div>
